import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { map } from 'rxjs';

export const privateGuard: CanMatchFn = (route, state) => {
  const authService = inject(AuthService);
  return authService.getUser().pipe( map(user => user ? true : false) );
};
